import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubscriptionService } from 'src/app/pages/subscription/services/subscription.service';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Injectable()
export class RefreshPlanDetailsInterceptor implements HttpInterceptor {


  constructor(
    private subscriptionService: SubscriptionService,
    private currentUserService: CurrentUserService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldRefresh = this.shouldRefreshPlanDetails(request.url);

    if (shouldRefresh) {
      this.currentUserService.currentUser.subscribe(user => {
        if (user?.id) {
          const userId = user.id;

          this.subscriptionService.getSubscriptionByIdForUsage(userId).subscribe((res) => {
            if (res) {
              sessionStorage.setItem('planUsage', JSON.stringify(res));
              this.currentUserService.setPlanUsageData(res);
            }
          });
        }
      });
    }

    return next.handle(request);
  }

  private shouldRefreshPlanDetails(url: string): boolean {
    const isTargetedUrl =
      url.includes('GetMaplistbyUseridAPI') ||
      url.includes('Getcharacterdetailsbyuserid') ||
      url.includes('gamemaster/Getgamemaster/') ||
      url.includes('subscription-plans'); // add more as needed

    return isTargetedUrl;
  }


}
